import type { ConfirmarSituacaoDialogProps } from "./types-confirmar-situacao-dialog";
import { useConfirmarSituacaoDialog } from "./use-confirmar-situacao-dialog";
import { ConfirmarSituacaoDialogView } from "./view-confirmar-situacao-dialog";

export function ConfirmarSituacaoDialog(props: ConfirmarSituacaoDialogProps) {
  const vm = useConfirmarSituacaoDialog(props);

  return <ConfirmarSituacaoDialogView {...vm} />;
}

export type * from "./types-confirmar-situacao-dialog";
